// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"3f95fb07","783":"3f95fb07"}[chunkId] + ".chunk.css";
};